export default __webpack_public_path__ + "static/media/marketing-video-poster-frame.47f2fd4c.png";